export default function sumPercentage(data: { percentage?: string }[]) {
  let sum = 0;
  for (const d of data) {
    sum += Number(d.percentage ?? '0');
  }
  return sum;
}
